import { redirect } from "@tanstack/react-router";
import { canContribute, canGovern, normalizeRole } from "@/lib/roles";
import { authClient } from "./auth-client";

export async function requireAuth() {
  const session = await authClient.getSession();
  if (!session.data) throw redirect({ to: "/login" });
  return session.data;
}

export async function requireContributor() {
  const session = await requireAuth();
  if (!canContribute(normalizeRole(session.user.role))) throw redirect({ to: "/" });
  return session;
}

export async function requireAdmin() {
  const session = await requireAuth();
  if (!canGovern(normalizeRole(session.user.role))) throw redirect({ to: "/" });
  return session;
}
